import { api } from './client';

export type Me = {
  id: number;
  email: string;
  displayName: string;
  phone: string | null;
  isAdmin: boolean;
  isApproved: boolean;
  sessionElevated?: boolean;
};

export type VerifyResponse = {
  ok: boolean;
  user: Omit<Me, 'sessionElevated'>;
  needsAdminPassword: boolean;
  needsProfile: boolean;
};

export const authApi = {
  requestCode: (email: string) =>
    api.post<{ ok: true }>('/api/auth/request-code', { email }),

  verifyCode: (email: string, code: string) =>
    api.post<VerifyResponse>('/api/auth/verify-code', { email, code }),

  adminPassword: (password: string) =>
    api.post<{ ok: true }>('/api/auth/admin-password', { password }),

  logout: () => api.post<{ ok: true }>('/api/auth/logout'),

  /** Drops admin elevation without logging out. */
  dropAdmin: () => api.post<{ ok: true }>('/api/auth/drop-admin'),

  me: () => api.get<{ user: Me | null }>('/api/me'),

  updateProfile: (input: { displayName: string; phone?: string }) =>
    api.patch<{ user: Me }>('/api/me', input),
};
